import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular';
import { elementAt } from 'rxjs/operator/elementAt';
import { AccountProvider } from '../../providers/account/account';
import { AwsProvider } from '../../providers/aws/aws';
import { UsersProvider } from '../../providers/users/users';

declare var google: any;

@IonicPage()
@Component({
  selector: 'page-agency-setup',
  templateUrl: 'agency-setup.html',
})
export class AgencySetupPage {
	userRecord: object;
  cognitoId: string;
  objectId: string;
  fields: Array<any>;
  formData: object = {};
  showSpinner: boolean;
  showPassword: boolean;
  errorMessages: Array<string> = [];
  showSuccess: boolean;
  selectedExistingUserIds: Array<any>;
  selectedUserToAdd: any;
  deletedClients: Array<any> = [];
  originalClientIds: object[] = [];
  users: object[] = [];
  clientUsersFiltered: Array<any>;
  start: number;

  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder;
  locationAutocompleteItems = [];
  industryAutocompleteItems = [];
  agentLabelAutocompleteItems = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public accountPro: AccountProvider, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public usersPro: UsersProvider) {
  	// null in position 1 of each array means the field will not be validated.
  	// industry and agentLabel get validated in their custom select functions.
  	// Position 2 contains the custom validation message for that field.
  	this.fields = [
  		['isAgency', 'text', 'invalid isAgency visible try true or false'],
  		['companyName', 'text', 'invalid, company name cannot be blank'],
  		['agencyVisible', 'text', 'invalid agency visible try true or false'], 
  		['clientUserIds', 'text', 'client user Ids form invalid'], 
  	];
		this.showSpinner = false; 
		this.userRecord = this.navParams.get('userRecord');
    this.cognitoId = this.navParams.get('cognitoId');
    this.objectId = this.userRecord['objectId'];
		this.resetForm();
    this.originalClientIds = this.setDefault(this.userRecord['clientUserIds'],[]);
    this.clientUsersFiltered = this.setDefault(this.userRecord['clientUserIds'],[]);
  }

  ionViewDidEnter() {
    this.usersPro.populateUsersWithUserId();
  }
  /**
   * helper function that copies array of objects by value
   * used for filtering
   * @param array array of objects to copy
   * @returns 
   */
  copyObjectArray(array){
    let newArray = [];
    array.forEach(element => {
      newArray.push({...element})
    });
    return newArray;
  }
  /**
   * Clear out all form fields and the form error messages
   */
  resetForm() {
  	this.showPassword = false;
    this.errorMessages = [];
    this.showSuccess = false;
    for (var i in this.fields) {
      this.formData[this.fields[i][0]] = '';
    }
    this.formData['isAgency'] = this.setDefault(this.userRecord['isAgency'],false);
  	this.formData['companyName'] = this.setDefault(this.userRecord['companyName'],""); //companyName in userRecord agencyName in html
  	this.formData['agencyVisible'] = this.setDefault(this.userRecord['agencyVisible'],true);
  	this.formData['clientUserIds'] = this.setDefault(this.userRecord['clientUserIds'],[]);
    console.log(this.formData['clientUserIds']);
  }
  /**
   * sets default if undefined or null
   * @param val val to check
   * @param def default val to assign
   * @returns val if exists def if not
   */
  setDefault(val,def){
    if(!val || val === undefined){
      return def;
    }
    else return val;
  }
  /**
   * @param item checkbox event.target.checked
   */
  setVisible(item){
    this.formData['agencyVisible'] = item;
  }
  /**
   * @param item checkbox event.target.checked
   */
  setIsAnAgency(item){
    this.formData['isAgency'] = item;
  }
  /**
   * @param item input event.target.value
   */
  setCompanyName(item){
    this.formData['companyName'] = item;
  }
  /**
   * self-explanatory 
   * @param item select change event.target.value
   */
  selectUserIdToAdd(item){
    this.selectedUserToAdd = item.replace(/\s/g, "");
  }
  /**
   * dynamically searches and filters displayed clientUserIds
   * @param item input field input event.target.value
   */
  filterClientUserIds(item){
    this.clientUsersFiltered = this.copyObjectArray(this.formData['clientUserIds']);
    this.clientUsersFiltered = this.clientUsersFiltered.filter((element) => 
    element.userId.toLowerCase().includes(item.toLowerCase()) 
    || element.username.toLowerCase().includes(item.toLowerCase()));
  }
  /**
   * gets newly selected items and adds them to array to track
   * @param item select change event.target.value
   */
  selectUserIds(item) {
    this.selectedExistingUserIds = [];
    for(let option of item){
      if(option.selected){
        let userIdAndName = option.value.split(',');
        this.selectedExistingUserIds.push({userId: userIdAndName[0], username: userIdAndName[1]});
      }    
    }
  }
  /**
   * removes all selected users from formData['clientUserIds']
   */
  deleteSelectedUserIds(){
    let temporaryArray = this.copyObjectArray(this.formData['clientUserIds']);
    temporaryArray.forEach((element,index)=>{
      for(let user of this.selectedExistingUserIds){
        if(user.userId.includes(element.userId)){
          this.deletedClients.push(user.userId);
          console.log('splicing');
          temporaryArray.splice(index, 1);
        }
      }
    });
    this.formData['clientUserIds'] = temporaryArray;
    this.clientUsersFiltered = temporaryArray;
    console.log(this.selectedExistingUserIds);
  }
  /**
   * adds single selected userIds to formData['clientUserIds']
   * @returns null
   */
  addSelectedUserIds(){
    console.log(this.selectedUserToAdd);
    if(this.selectedUserToAdd != undefined){
      let userIdAndName = this.selectedUserToAdd.split(',');
      console.log(this.selectedUserToAdd);
      if(!this.isAddedUserValid(userIdAndName)) return;
      let username = '';
      let prompt = this.alertCtrl.create({
        title: 'Enter display name for the client',
        inputs: [
          {
            name: 'u',
            placeholder: this.selectedUserToAdd.username,
            type: 'text',
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: (data: any) => {
              console.log('Canceled', data);
            }
          },
          {
            text: 'Done!',
            handler: (data: any) => {
              console.log('data', this.selectedUserToAdd);
              let userIdAndName = this.selectedUserToAdd.split(',');
              console.log('Saved Information', data);
              username = data.u;
              // Delete added user form deleted if user is in deleted
              let indexOfDel: number = this.deletedClients.indexOf(userIdAndName[1]);
              console.log(indexOfDel);
              if(indexOfDel > -1) this.deletedClients.splice(indexOfDel,1);
              this.formData['clientUserIds'].push({userId: userIdAndName[1] , username: username});
              this.clientUsersFiltered = this.formData['clientUserIds'];
            }
          }
        ]
      });
      prompt.present();
    }
  }
  /**
   * checks wether user Id exists, wether its valid and wether
   * its already in the form data
   * @param userIdAndName userIdAndName to check
   * @returns boolean
   */
  isAddedUserValid(userIdAndName){
    // if the form data does not have the user Id already
    for(let client of this.formData['clientUserIds']){
      if(client.userId === userIdAndName[1]){
        alert("client aready exists");
        return false;
      }
    }
    // needs a comma for the split to work
    if(!this.selectedUserToAdd.includes(',')){
      alert("enter valid user format");
      return false;
    }
    // can't add a user that doesen't exist
    let realUser: boolean = false;
    for(let client of this.usersPro.usersWithUserId){
      if(client['userId'] === userIdAndName[1]){
        realUser = true;
      }
    }
    if(!realUser){
      alert('not a registered user');
      return false;
    }
    return true;
  }
	/**
   * Check each field for validity, collect error messages for all bad fields, 
   * returns true if entire form is valid, false otherwise.
   */
  isFormValid() {
    var valid: boolean = true;
    for (var i = 0; i < this.fields.length; i++) {
      if(this.fields[i][1] !== null){
	      var fieldData: Array<string> = this.fields[i];
	      var result: boolean = this.isFieldValid(fieldData);
        if (!result) { // invalid field
	        valid = false;
	      }
	    }
    }
    return valid;
  }

  /**
   * Check if a field is valid, returns true if it is and false + adds error 
   * message to array if it is not
   * @param {String} field  field name to check validity of
   */
  isFieldValid(field: Array<string>) {

    if (field[1] == 'text') {
      if (this.validateTextInput(field[0])) {
        return true;
      } else {
      	this.errorMessages.push(field[2]);
        return false;
      }
    }
  }

  validateTextInput(field: string) {
    return this.formData[field].trim().length > 0;
  }

  submit() {
    //this.play();
  	this.errorMessages = [];
    if (true) {
      console.log("validated");
      this.showSpinner = true;
      this.errorMessages = [];
      this.editAccount();
    }
  }

  // Need to use remove to remove empty attributes. Create 2 objects within data: update & remove. 
  // If a field is empty, or doesn't exist, it goes in the remove object.
  editAccount() {
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    var data: object = {
    	'objectId': this.objectId,
      'isAgency': this.formData['isAgency'],
      'clientUserIds': this.formData['clientUserIds'],
      'companyName': this.formData['companyName'].trim(),
      'agencyVisible': this.formData['agencyVisible'],
      'deletedClients': this.deletedClients,
    };
    console.log("data going to the lambda");
    console.log(data);
    return this.accountPro.editAgency(data)
      .then((result) => {
        loading.dismiss();
        this.showSpinner = false;
        if (result['success']) {
          //this.showSuccess = true;
          let msg = result['message'] || 'The user account has been edited.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        } else {
        	this.errorMessages.push(result['message']);
        	//this.showSuccess = false;
          let msg = result['message'] || 'Error editing user record. Please try again.';
          let alert = this.alertCtrl.create({
            message: msg,
            buttons: ['Ok'],
            enableBackdropDismiss: false
          });
          alert.present();
        }
      });
  }
}




// WEBPACK FOOTER //
// ./src/pages/agency-setup/agency-setup.ts